import type {
	StreamAiCreditDenied,
	StreamError,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const convertCreditDenialToStreamError = (
	streamMessage: StreamAiCreditDenied,
): StreamError => ({
	type: 'ERROR',
	message: streamMessage.message,
	millisOffset: streamMessage.millisOffset ?? 0,
	metadata: streamMessage.metadata ? { request_id: streamMessage.metadata.request_id } : null,
});
